import React from "react";
import { Col, Row } from "react-bootstrap";
import ReportValue from "@frameworks/web/components/generic/commonTableVal";
const ResearchCallGeneric = (props) => {
    var _a, _b;
    return (React.createElement("div", { className: `Researchcall-generic  ${props.parentClass ? props.parentClass : ""}` },
        React.createElement(Row, { className: "m-0" },
            React.createElement(Col, { lg: 12, className: "flexJustifySpaceBetween p-0" },
                React.createElement(Col, { className: "d-flex" },
                    React.createElement("span", { className: "researchtag EncodeSans_10_500 flexCenter" }, "R"),
                    React.createElement("span", { className: "EncodeSans_14_600 txt_blackOne1 ps-2" }, props.title)),
                React.createElement(Col, { className: "buttonchange-block taRight" },
                    React.createElement("label", { className: "Buy" }, "Buy")))),
        props.researchCall &&
            ((_a = props.researchCall) === null || _a === void 0 ? void 0 : _a.list) &&
            ((_b = props.researchCall) === null || _b === void 0 ? void 0 : _b.list.map((item, i) => {
                if ((props === null || props === void 0 ? void 0 : props.limit) ? i < props.limit : true)
                    return (React.createElement(Row, { key: i, className: "research-data" },
                        React.createElement(Col, null,
                            React.createElement("div", null, "RecoDate"),
                            React.createElement("div", null, item.startDate)),
                        React.createElement(Col, null,
                            React.createElement("div", null, "Reco Price"),
                            React.createElement("div", null, item.entryPrice)),
                        React.createElement(Col, null,
                            React.createElement("div", null, "Tgt Price"),
                            React.createElement("div", null, item.targetPriceOne)),
                        React.createElement(Col, null,
                            React.createElement("div", null, "Current Returns"),
                            React.createElement("div", null,
                                React.createElement(ReportValue, { val: item.returnFromRC, stream: true, onlyval: false, percentage: true })))));
            })),
        props.isviewPresent ? ("") : (React.createElement(Row, null,
            React.createElement("div", { className: "EncodeSans_12_500 txt-secondary-navy alignright research-view" },
                "View ",
                React.createElement("span", { className: "edel-icon-arrow-right" }))))));
};
export default ResearchCallGeneric;
